<template>
  <div class="about">
    <h1>企业简介</h1>
    <p>
      易度网成立于1998年，在天津滨海高新技术产业开发区登记，主要是以经营第二类互联网视听节目服务中的第三项：文艺、娱乐、科技、财经、体育、教育等专业类视听节目的制作（不含采访）、播出服务；第五项动画片类视听节目的汇集、播出服务的平台。平台容纳了大量益智类动画片。
    </p>
    <p>信息网络传播视听节目许可证</p>
    <p>中国网络视听节目服务协会会员单位</p>
    <p>联系电话：010-52926669</p>
    <p>联系邮箱：yinxue@tal.com</p>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.about {
  width: vw(1920px);
  padding: 110px 200px 20px;
  p{
    margin-top: 20px;
  }
}
</style>